import React, { useState } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import { useDispatch } from "react-redux";

import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond/dist/filepond.min.css";
import "./uploader.css";
import MediaRequests from "services/media";
import { baseUrl } from "@jumbo/constants/baseUrl";

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const MediaUploader = () => {
  const [files, setFiles] = useState([]);
  const dispatch = useDispatch();

  return (
    <div>
      <FilePond
        files={files}
        onupdatefiles={setFiles}
        allowMultiple={false}
        maxFiles={1}
        name="file"
        labelTapToUndo={"بستن"}
        labelFileLoading="در حال آپلود"
        labelFileProcessingAborted="لغو عملیات"
        labelTapToCancel="لغو عملیات"
        labelFileProcessingComplete="با موفقیت آپلود شد"
        labelFileProcessing="در حال آپلود"
        labelFileLoadError="خطا در آپلود فایل"
        labelFileSizeNotAvailable="سایز مجاز نمی‌باشد"
        labelInvalidField="خطا"
        server={{
          process: {
            url: `${baseUrl}file/upload`,
            method: "POST",
            headers: {
              Authorization: `Bearer ${
                localStorage.getItem("Token")
                  ? localStorage.getItem("Token")
                  : sessionStorage.getItem("Token")
              }`,
            },
            ondata: (formData) => {
              // Explicitly encode file names in UTF-8
              const newFormData = new FormData();
              for (let [key, value] of formData.entries()) {
                if ((key === "file") && (typeof value==="object")) {
                  const encodedFile = new File([value], encodeURIComponent(value.name), {
                    type: value.type,
                  });
                  newFormData.append("file", encodedFile);
                } else {
                  newFormData.append(key, value);
                }
              }
              return newFormData;
            },
            onload: (response) => {
              setTimeout(() => {
                dispatch(MediaRequests.getmediaList(1));
                setFiles([]);
              }, 3000);
            },
            onerror: (response) => console.log(response),
          },
        }}
        labelIdle="برای آپلود فایل های خود را به اینجا بکشید یا کلیک کنید"
      />
    </div>
  );
};

export default MediaUploader;
